import { useRequest } from 'features/request/useRequest';
import type { AnyObject } from 'types/AnyObject';

import { useCallback, useMemo, useState } from 'react';

import { uerWorkOrderMtrRowsForComparisonGql } from '../matchMtrDialogQueries';

interface IUseUerMtrRowsForComparison {
    workOrderPriceId: number;
}

const requestId = 'uerMtrRowsForComparison';

export const useUerMtrRowsForComparison = (props: IUseUerMtrRowsForComparison) => {
    const { workOrderPriceId } = props;

    const [filterWhere, setFilterWhere] = useState<AnyObject | undefined>(undefined);

    const mtrRowsForComparisonVariables = useMemo(
        () => ({
            workOrderPriceId,
            where: filterWhere,
        }),
        [filterWhere, workOrderPriceId],
    );

    const [uerMtrRowsForComparisonData, uerMtrRowsForComparisonStatus] = useRequest({
        requestId,
        query: uerWorkOrderMtrRowsForComparisonGql,
        variables: mtrRowsForComparisonVariables,
    });

    const uerMtrRowsForComparisonItems = useMemo(
        () => uerMtrRowsForComparisonData?.uerWorkOrderMtrRowsForComparison?.items,
        [uerMtrRowsForComparisonData?.uerWorkOrderMtrRowsForComparison?.items],
    );

    const changeFilterHandler = useCallback(
        ({ fieldName, checkedValues }: { fieldName: string; checkedValues: string[] }) => {
            const newValue = checkedValues.length
                ? {
                      in: checkedValues,
                  }
                : undefined;

            setFilterWhere((prevFilterState) => ({
                ...prevFilterState,
                and: {
                    ...prevFilterState?.and,
                    [fieldName]: newValue,
                },
            }));
        },
        [],
    );

    return {
        uerMtrRowsForComparisonItems,
        uerMtrRowsForComparisonStatus,
        changeFilterHandler,
    };
};
